export default __webpack_public_path__ + "static/logo white-980c9f012d68c91bf658a3e9f269df49.png";